import React from 'react';
import { IframeContent } from './IframeContent';

export const HyperTextContent: React.FC<{
  src: string;
  title: string;
}> = ({ src, title }) => {
  return <IframeContent src={src} title={title} />;
};
